// 最終工時表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import axios from 'axios';
import swal from 'sweetalert2';
import moment from 'moment';
import Calendar from '../../Calendar';
import API from '../../../middleware/API';
import {GetStoreRole,years, monthNames} from '../../../const/constant';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../scss/components/pages/signTime.scss';
import IncomeChart from '../../IncomeChart';
import CostPieChart from '../../CostPieChart';
import { 
  getFinalWorkSheet,
  getExpectedWorkSheet,
  InitAPIStatus
} from '../../../store/action';
import { forEach } from 'lodash';

class FinalWorkTime extends Component {
  constructor(props) {
    super(props);
    let start = moment().add(0, 'month').format('YYYY-MM') + '-01';
    let end = moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD');
    this.state = {
      start: moment().add(0, 'month').format('YYYY-MM') + '-01',
      end: moment(start).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD'),
      totalExpect: 0,
      totalFinal: 0,
      loading:false,
      calendarConfig: {
        calendarType: "month",
        defaultView: "month",
        draggable: false,
        isEventClick: true,
        isDayClick: true,
        header: {
          left: 'today prev,next',
          center: 'title',
          right: 'month',
        },
      },
      events: [],
      monthReports: [],
      storeId :localStorage.getItem('current_store_id'),
      dDay : '',
      startat : moment(start),
      endat : moment(end),
      role : GetStoreRole(localStorage.getItem('current_store_id')),
      monthReports: [0],
      yearReports: [0],
      costReports: [0],
      year: moment().format('YYYY'),
      month: moment().format('MM'),
    }
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleGetFinalWorkSheet = this.handleGetFinalWorkSheet.bind(this);
    this.generateExcel = this.generateExcel.bind(this);
    this.generateExcelv2 = this.generateExcelv2.bind(this);
    this.generateExpectv2 = this.generateExpectv2.bind(this);
    this.handleSearchStartDateChange = this.handleSearchStartDateChange.bind(this);
    this.handleSearchEndDateChange = this.handleSearchEndDateChange.bind(this);
    this.onChangeMonthFunc = this.onChangeMonthFunc.bind(this);
    this.onChangeYearFunc = this.onChangeYearFunc.bind(this);
    this.handleUpdateChartData = this.handleUpdateChartData.bind(this);
  }

  componentDidMount() {
    //this.props.getFinalWorkSheet(8,'','');
    //this.props.getExpectedWorkSheet();

  }
  onChangeMonthFunc(e) {
    this.setState({
      month: e.target.value,
      monthReports: [0],
    }, this.handleUpdateChartData);
  }

  onChangeYearFunc(e) {
    this.setState({
      year: e.target.value,
      monthReports: [0],
      yearReports: [0],
    }, this.handleUpdateChartData);
  }

  handleUpdateChartData() {
    const {
      month, year,
    } = this.state;
    axios.all([
      API.get(`/Chart?date=${`${year}-${month}-01`}&isYear=false`),
            API.get(`/Chart?date=${`${year}-01-01`}&isYear=true`),
            API.get(`/Piechart?year=${`${year}`}&month=${`${month}`}`),
      //this.getIPData()
    ])
    .then(axios.spread((monthReports, yearReports, costReports, 
        //ipAddress
        ) => {
        
        this.setState({
          monthReports,
          yearReports, costReports, 
          //ipData: ipAddress.data.ip_address
        });
      }));
            
  }
  componentWillReceiveProps(nextProps) {
    let newFinalEvents = [];
    var totalFinal = 0
    var totalExpect = 0

    nextProps.finalWorkState.forEach(event => {
      totalFinal += event.expectedCost;

      let newObj = {
        title: '最終成本: ' + event.expectedCost,
        start: moment(event.start).format('YYYY-MM-DD'),
        backgroundColor: 'brown',
        borderColor: 'brown',
        type:'final'
      }
      newFinalEvents.push(newObj);
    });

    let newExpectedEvents = [];
    nextProps.expectdWorkState.forEach(event => {
      totalExpect += event.expectedCost;

      let newObj = {
        title: '預期成本: ' + event.expectedCost,
        start: moment(event.start).format('YYYY-MM-DD'),
        backgroundColor: 'darkblue',
        borderColor: 'darkblue',
        type:'expected'
      }
      newExpectedEvents.push(newObj);
    });
    var fEvent = newFinalEvents.concat(newExpectedEvents);
    this.state.monthReports.forEach((element) => 
    {      
      if(fEvent.length > 0){
        var yearMonthStr = moment(fEvent[0].start).format('YYYY-MM-')
        fEvent.push({
          backgroundColor: "green",
          borderColor: "green",
          start:yearMonthStr+element.time.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          }),
          title:"當日營收: "+element.income,
          type:"income"
        });
      }

    });
    this.setState({
      events: fEvent,
      totalExpect: totalExpect,
      totalFinal: totalFinal
    });
  }

  handleDayClick(date) {
    this.props.history.push(`/finalWorkTimeByDay/${date.format('YYYY-MM-DD')}`);
  }

  handleEventClick(event) {
    if(event.type === 'final'){
      this.props.history.push(`/finalWorkTimeByDay/${event.start.format('YYYY-MM-DD')}`);
    }else{
      this.props.history.push(`/expectedWorkTimeByDay/${event.start.format('YYYY-MM-DD')}`);
    }
    //this.props.history.push(`/finalWorkTimeByDay/${event.start.format('YYYY-MM-DD')}`);
  }
  generateExcel() {
    console.log(this.state.dDay)
    var lastDay = moment(this.state.dDay, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
    axios({
      url:process.env.REACT_APP_NODE_ENV === 'development'?
      'https://www.liangshishu.link:46890/api/'+'/Chart/FinalWorkTimeSheet?timeOffset=8&start='+this.state.dDay+'&end='+lastDay:
      'https://www.liangshishu.link:46888/api/'+'/Chart/FinalWorkTimeSheet?timeOffset=8&start='+this.state.dDay+'&end='+lastDay,
      method: 'GET',
      headers:{
'Authorization': 'bearer ' + localStorage.getItem('access_token'),
  'StoreId':this.state.storeId },
  responseType: 'blob'}).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '最終成本.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
      }).catch((error) => {
      swal({
        type: 'error',
        title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
        heightAuto: false,
      });
    });

  }
  generateExpectv2() {
    var lastDay = moment(this.state.dDay, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
    axios({
      url:process.env.REACT_APP_NODE_ENV === 'development'?
      'https://www.liangshishu.link:46890/api/'+'/Event/DownloadExpectWorkTimeSheet?startat='+this.state.startat.format('YYYY-MM-DD')+'&endat='+this.state.endat.format('YYYY-MM-DD'):
      'https://www.liangshishu.link:46888/api/'+'/Event/DownloadExpectWorkTimeSheet?startat='+this.state.startat.format('YYYY-MM-DD')+'&endat='+this.state.endat.format('YYYY-MM-DD'),
      method: 'GET',
      headers:{
'Authorization': 'bearer ' + localStorage.getItem('access_token'),
  'StoreId':this.state.storeId },
  responseType: 'blob'}).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.state.startat.format('YYYY-MM-DD')+'~'+this.state.endat.format('YYYY-MM-DD')+'預期成本.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
      this.setState({loading:false})
      }).catch((error) => {
      this.setState({loading:false});
      swal({
        type: 'error',
        title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
        heightAuto: false,
      });
    });

  }
  generateExcelv2() {
    var lastDay = moment(this.state.dDay, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
    axios({
      url:process.env.REACT_APP_NODE_ENV === 'development'?
      'https://www.liangshishu.link:46890/api/'+'/Event/DownloadFinalWorkTimeSheet?startat='+this.state.startat.format('YYYY-MM-DD')+'&endat='+this.state.endat.format('YYYY-MM-DD'):
      'https://www.liangshishu.link:46888/api/'+'/Event/DownloadFinalWorkTimeSheet?startat='+this.state.startat.format('YYYY-MM-DD')+'&endat='+this.state.endat.format('YYYY-MM-DD'),
      method: 'GET',
      headers:{
'Authorization': 'bearer ' + localStorage.getItem('access_token'),
  'StoreId':this.state.storeId },
  responseType: 'blob'}).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.state.startat.format('YYYY-MM-DD')+'~'+this.state.endat.format('YYYY-MM-DD')+'最終成本.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
      this.setState({loading:false})
      }).catch((error) => {
      this.setState({loading:false});
      swal({
        type: 'error',
        title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
        heightAuto: false,
      });
    });

  }
  
  handleGetFinalWorkSheet(timeoffset,start,end) {
    console.log(start)
    const {
      
      month, year,
     
    } = this.state;
    axios.all([
      API.get(`/Chart?date=${start}&isYear=false`),
            API.get(`/Chart?date=${`${year}-${month}-01`}&isYear=true`),
            API.get(`/Piechart?year=${`${year}`}&month=${`${month}`}`),
      //this.getIPData()
    ])
      .then(axios.spread((monthReports, yearReports, costReports, 
        //ipAddress
        ) => {
        
        this.setState({
          monthReports,
          yearReports, costReports, 
          dDay:start
          //ipData: ipAddress.data.ip_address
        }, () => {
          this.props.getFinalWorkSheet(timeoffset,start,end);
          this.props.getExpectedWorkSheet(start, end);
        });
      }));
  }
  handleSearchEndDateChange(date) {
    this.setState({
      endat: date
    })
  }
  handleSearchStartDateChange(date) {
    this.setState({
      startat: date
    })
  }
  render() {
        const {
      
      month, year,
      monthReports, yearReports, costReports,
      
    } = this.state;
    var xlsnBtn = (<button className="btn btn-md edit m-r-16" onClick={() => {this.setState({loading:true}); this.generateExcelv2(); } }>下載最終</button>);
    var xlsnExpectBtn = (<button className="btn btn-md success m-r-16" onClick={() => {this.setState({loading:true}); this.generateExpectv2(); } }>下載預期</button>);

  if (this.state.loading) {
    return (
      <div className="loading__overlay">
        <div className="loading__content">
          <div className="spinner" />
          <h1>資料下載中</h1>
        </div>
      </div>
    );
  }
    return (
    <div className="u-block">
      
      <div className="u-title">最終/預期人事成本總計:{this.state.totalFinal}/{this.state.totalExpect}</div>
      <div className="sign-notice">
        <div className="u-notice">最終人事成本: 實際打卡成本+休假成本+加班單成本</div>
        <div className="u-notice">預期人事成本: 預期排班成本+休假成本</div>

        </div>
      <div className="u-search-box">
      <div className="date-input">
            <span style={{flex: '0 0 54px'}}>時間：</span>
            <DatePicker
              id="date_picker_searchStartDate"
              locale="zh-tw"
              dateFormat="YYYY-MM-DD"
              selected={this.state.startat}
              onChange={this.handleSearchStartDateChange}
              className="u-form__input mobile-hide"
              disabledKeyboardNavigation
            />
            <button
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('date_picker_searchStartDate').click();
                }}
            >
              {this.state.startat.format('l')}
            </button>
            
          </div>
          <div className="date-input">
            <span style={{flex: '0 0 54px'}}>到：</span>
            <DatePicker
              id="date_picker_searchEndDate"
              locale="zh-tw"
              dateFormat="YYYY-MM-DD"
              selected={this.state.endat}
              onChange={this.handleSearchEndDateChange}
              className="u-form__input mobile-hide"
              disabledKeyboardNavigation
            />
            <button
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('date_picker_searchEndDate').click();
                }}
            >
              {this.state.endat.format('l')}
            </button>
          </div>
          {xlsnBtn}
          {xlsnExpectBtn}
        </div>
      <Calendar {...this.state.calendarConfig} 
        events={this.state.events}
        dayClick={this.handleDayClick}
        eventClick={this.handleEventClick}
        finalWorkTimeFunc={this.handleGetFinalWorkSheet}
      />
          <div id="income-block" className="m-t-16">
            <div className="u-search-box">
              <div className="date-input">
                <span>年：</span>
                <select
                  value={year}
                  className="u-form__select"
                  onChange={this.onChangeYearFunc}
                >
                  {
                    years.map(year => (
                      <option key={year.id} value={year.id}>{year.text}</option>
                    ))
                  }
                </select>
              </div>
              <div className="date-input">
                <span>月：</span>
                <select
                  value={month}
                  className="u-form__select"
                  onChange={this.onChangeMonthFunc}
                >
                  {
                    monthNames.map((monthName, index) => {
                      const monthValue = index < 9 ? `0${index + 1}` : index + 1;
                      return (
                        <option key={monthValue} value={monthValue}>{monthName}</option>
                      );
                    })
                  }
                </select>
              </div>
            </div>
            <IncomeChart
              title={`${year}-${month}月的每日營收和最終成本折線圖`}
              reports={monthReports}
              strIncome="每日營收"
              strCost="每日成本"
              higher={true}
              showPartTimeCost={true}
            />
            <IncomeChart
              title={`${year}年的每月營收和最終成本折線圖`}
              reports={yearReports}
              strIncome="每月營收"
              strCost="每月成本"
              higher={true}
              showPartTimeCost={true}
            />
            <CostPieChart
              title={`${year}年${month}月的各部門成本比例`}
              reports={costReports}
              strIncome="每月營收"
              strCost="每月成本"
            />
            <br />
            <br />
          </div>
    </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  finalWorkState: store.finalWorkState,
  expectdWorkState: store.expectdWorkState
})

export default connect(mapStateToProps,{
  getFinalWorkSheet,
  getExpectedWorkSheet,
  InitAPIStatus
})(withRouter(FinalWorkTime));
